import { render } from "./TemplateName.vue?vue&type=template&id=e2382b8e&scoped=true"
import script from "./TemplateName.vue?vue&type=script&lang=ts"
export * from "./TemplateName.vue?vue&type=script&lang=ts"

import "./TemplateName.vue?vue&type=style&index=0&id=e2382b8e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e2382b8e"

export default script